<form form="ngForm">
    <select [(ngModel)]="estado" id="relacao" name="relacao" class="form-control" (change)="onChange()" appShowErrorMessages [required]="required">
      <option value="1">Casado</option>
      <option value="2">Solteiro</option>
      <option value="3">Viúvo</option>
      <option value="4">Divorciado</option>
      <option value="5">Separado</option>
      <option value="6">Casado com. universal bens</option>
      <option value="7">Casado com. parcial bens</option>
      <option value="8">Casado separação bens</option>
      <option value="9">Outro</option>
   </select>
</form>